import script from "./StrategyTree.vue?vue&type=script&setup=true&lang=js"
export * from "./StrategyTree.vue?vue&type=script&setup=true&lang=js"

import "./StrategyTree.vue?vue&type=style&index=0&id=6e4beb22&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e4beb22"]])

export default __exports__